@switch (columnName) {
  @case ('formStatus') {
    {{ 'formStatus_' + element.formStatus | translate }}
  }
  @case ('version') {
    V{{ element.version }}
  }
  @case ('formVersion') {
    V{{ element.formVersion }}
  }
  @case ('created') {
    {{ element.created | date }}
  }
  @case ('lastUpdate') {
    {{ element.lastUpdate | date: dateFormat }}
  }
  @case ('actions') {
    <app-ui-button
      text="{{ 'clone' | translate }}"
      buttonType="secondary"
      (click)="openCloneDialog()"
    ></app-ui-button>
  }
  @default {
    {{ element[columnName] }}
  }
}
